import { useEffect, useState } from 'react'
import { moldAPI, type MoldNeed } from './moldApi'

export function useMoldReadiness(articles: string[], refreshToken: unknown = null) {
  const [items, setItems] = useState<Record<string, MoldNeed>>({})
  const [error, setError] = useState(false)
  const key = [...new Set(articles)].sort().join(',')
  useEffect(() => {
    const controller = new AbortController()
    setItems({}); setError(false)
    const load = async () => {
      const list = key ? key.split(',') : []
      for (let offset = 0; offset < list.length; offset += 20) {
        const result = await moldAPI.readiness(list.slice(offset, offset + 20), controller.signal)
        if (controller.signal.aborted) return
        setItems((current) => ({ ...current, ...Object.fromEntries(result.items.map((item) => [item.article, item])) }))
      }
    }
    void load().catch(() => { if (!controller.signal.aborted) setError(true) })
    return () => controller.abort()
  }, [key, refreshToken])
  return { items, error }
}
